// extracted by mini-css-extract-plugin
export default {"SettingsHeader":"_SettingsHeader--p7HvP","SettingsTabContainer":"_SettingsTabContainer--vPU7T"};